// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    POST_NATIVE_AD_LOADING() {
      return {
        isLoading: true,
        data: action.postNativeAd
      };
    },
    POST_NATIVE_AD_LOADED() {
      const { nativeType } = action.postNativeAd;
      return {
        isLoading: false,
        data: {
          [nativeType]: {
            posts: action.postNativeAd.posts
          }
        }
      };
    },
    POST_NATIVE_AD_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.postNativeAd.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
